import React from 'react';
import styled from 'styled-components';
import { colors } from '../../config/styles';

const ErrorMessage = styled.div`
  margin: 12px 0;
  color: ${colors.mainError};
  text-align: left;

  &.regular {
    font-size: 14px;
    font-weight: 600;
  }

  &.minified {
    font-size: 12px;
    font-weight: 500;
  }
`;

interface IProps {
  minified?: boolean;
  error: string;
}

export default ({ error, minified }: IProps) => {
  return (
    <ErrorMessage className={minified ? 'minified' : 'regular'}>
      {error}
    </ErrorMessage>
  );
};
